import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { reorderUrl: String }

  #draggedCol = null
  #handles    = []
  #cols       = []

  connect() {
    this.#cols = [...this.element.children].filter(el => el.dataset.stepId)

    this.#cols.forEach(col => {
      const header = col.querySelector(".kanban-column-header")
      if (header) {
        header.setAttribute("draggable", "true")
        header.addEventListener("dragstart", this.#onDragStart)
        this.#handles.push(header)
      }
      col.addEventListener("dragover",  this.#onDragOver)
      col.addEventListener("dragleave", this.#onDragLeave)
      col.addEventListener("drop",      this.#onDrop)
    })
  }

  disconnect() {
    this.#handles.forEach(h => {
      h.removeAttribute("draggable")
      h.removeEventListener("dragstart", this.#onDragStart)
    })
    this.#cols.forEach(col => {
      col.removeEventListener("dragover",  this.#onDragOver)
      col.removeEventListener("dragleave", this.#onDragLeave)
      col.removeEventListener("drop",      this.#onDrop)
    })
    this.#handles = []
    this.#cols    = []
  }

  #onDragStart = (e) => {
    this.#draggedCol = e.currentTarget.closest("[data-step-id]")
    if (!this.#draggedCol) return
    e.dataTransfer.effectAllowed = "move"
    e.dataTransfer.setData("text/plain", this.#draggedCol.dataset.stepId)
    e.dataTransfer.setDragImage(this.#draggedCol, 20, 20)
    this.#draggedCol.classList.add("kanban-column--dragging")
  }

  #onDragOver = (e) => {
    e.preventDefault()
    if (!this.#draggedCol) return
    e.dataTransfer.dropEffect = "move"
    const target = e.currentTarget
    if (target === this.#draggedCol) return
    target.classList.add("kanban-column--drag-over")
  }

  #onDragLeave = (e) => {
    e.currentTarget.classList.remove("kanban-column--drag-over")
  }

  #onDrop = (e) => {
    e.preventDefault()
    const target = e.currentTarget
    target.classList.remove("kanban-column--drag-over")
    if (!this.#draggedCol || target === this.#draggedCol) return

    const rect = target.getBoundingClientRect()
    if (e.clientX < rect.left + rect.width / 2) {
      this.element.insertBefore(this.#draggedCol, target)
    } else {
      this.element.insertBefore(this.#draggedCol, target.nextSibling)
    }

    this.#draggedCol.classList.remove("kanban-column--dragging")
    this.#draggedCol = null

    const ids = [...this.element.children].map(col => col.dataset.stepId).filter(Boolean)
    this.#save(ids)
  }

  async #save(ids) {
    await fetch(this.reorderUrlValue, {
      method:  "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ids })
    })
  }
}
